import { avatarSvgUri, avatarBg } from "../lib/api";

// Chosen icon avatar (safe generated character) with an initials-monogram fallback.
export default function RoasterAvatar({ avatar, initials = "R", size = 44, ring = "#ff4500" }) {
  const uri = avatar ? avatarSvgUri(avatar) : null;
  return (
    <div style={{
      width: size, height: size, borderRadius: 9999, flexShrink: 0, overflow: "hidden",
      background: uri ? avatarBg(avatar) : `${ring}26`, border: `2px solid ${ring}`,
      display: "flex", alignItems: "center", justifyContent: "center",
      fontFamily: "'Oswald', sans-serif", fontWeight: 700, fontSize: Math.round(size * 0.4), color: "#fff",
    }}>
      {uri ? <img src={uri} alt="" style={{ width: size * 0.6, height: size * 0.6 }} /> : initials}
    </div>
  );
}
